import { combineReducers } from 'redux';
import { createReducers } from '../ducksHelpers';
import { payoutPreferenceSettings } from './payoutPreference';
import { payoutStatementSettings } from './payoutStatement';

const settingList = [
  payoutPreferenceSettings,
  payoutStatementSettings,
];

const payoutsReducer = combineReducers(createReducers(settingList));

export default payoutsReducer;
